class InputPassword {
    constructor(element) {
        this.element = element;
        this.groupPassword = (this.element) ? this.element.nextElementSibling : null;
        this.init();
    }

    attachListeners() {
        if (this.groupPassword) {
            this.groupPassword.addEventListener('click', () => {
                this.toggle();
            });
            // initial
            if (this.element.type === 'password') {
                this.hide();
            } else {
                this.show();
            }
        }
    }

    hide() {
        this.element.type = 'password';
        if (this.groupPassword) {
            this.groupPassword.setAttribute('aria-label', 'Show password');
        }
    }

    show() {
        this.element.type = 'text';
        if (this.groupPassword) {
            this.groupPassword.setAttribute('aria-label', 'Hide password');
        }
    }

    toggle() {
        if (this.element.type === 'password') {
            this.show();
        } else {
            this.hide();
        }
    }

    value() {
        return this.element.value;
    }

    val() {
        return this.value();
    }

    init() {
        this.attachListeners();
    }
}

// Inisialisasi class setelah DOM siap
document.addEventListener('DOMContentLoaded', () => {
    new InputPassword();
});

export default InputPassword;